import {
  DropdownInput,
  Form,
  TextInput,
  useForm,
} from "@validereinc/common-components";
import {
  DelayActionSchema,
  WorkflowTriggerTimePeriod,
} from "@validereinc/domain";
import {
  toTitleCaseString,
  validateNumericBounds,
} from "@validereinc/utilities";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import {
  DelayFormValuesType,
  useWorkflowConfigurationFormStore,
} from "../WorkflowConfigurationFormStore";
import styles from "./WorkflowConfigurationDelayDetails.module.scss";

const cx = classNames.bind(styles);

const TimePeriodDropdownOptions = Object.values(WorkflowTriggerTimePeriod).map(
  (timePeriod) => ({
    label: toTitleCaseString(timePeriod, { intent: "ui" }),
    value: timePeriod,
  })
);

const WorkflowConfigurationDelayDetails = () => {
  const { setDelay, setDelayIsValid, getDelay } =
    useWorkflowConfigurationFormStore();

  const storeValues = getDelay();

  const handleValueChange = (
    key: "duration" | "time_period",
    value: unknown
  ) => {
    if (storeValues) {
      setDelay({
        ...storeValues,
        [key]: value,
      });
    }
  };

  const form = useForm<DelayFormValuesType>({
    values: storeValues,
  });

  useEffect(() => {
    setDelayIsValid(form.formState.isValid);
  }, [form.formState.isValid, setDelayIsValid]);

  return (
    <Form {...form}>
      <div className={cx("container")}>
        <TextInput
          name={DelayActionSchema.keyof().Enum.duration}
          label="Delay Length"
          className={cx("delay-length-input")}
          type="number"
          rules={{
            validate: {
              mustBePositive: (value: number) =>
                validateNumericBounds(value, { min: 1 }, "Delay Length"),
            },
          }}
          isRequired
          onChange={(value: string) => handleValueChange("duration", value)}
        />
        <DropdownInput
          name={DelayActionSchema.keyof().Enum.time_period}
          label="Time Period"
          className={cx("time-period-input")}
          labelKey="label"
          valueKey="value"
          options={TimePeriodDropdownOptions}
          isRequired
          noSearchDebounce
          onChange={(value: string) => handleValueChange("time_period", value)}
        />
      </div>
    </Form>
  );
};

export default WorkflowConfigurationDelayDetails;
